import React from "react";
import { motion } from "framer-motion";

// Consistent editorial page intro for inner pages
export const PageIntro = ({ label, titleLines, subtitle }) => (
  <section className="relative pt-36 md:pt-44 pb-12 md:pb-16 px-5 md:px-10">
    <div className="max-w-[1400px] mx-auto">
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.7 }}
        data-testid="page-label"
        className="font-mono text-xs uppercase tracking-[0.28em] text-brand-sprout mb-6"
      >
        {label}
      </motion.p>
      <h1 className="font-serif font-light tracking-tight leading-[1.0] text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] text-brand-ink max-w-5xl">
        {titleLines.map((line, i) => (
          <motion.span
            key={i}
            className="block"
            initial={{ opacity: 0, y: 34 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.15 + i * 0.1, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        ))}
      </h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35 }}
          className="mt-8 max-w-2xl text-base md:text-lg text-brand-muted leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
